module.exports = __webpack_public_path__ + "img/a time when the girl lived.f1188244.png";